module.exports = __webpack_public_path__ + "img/pgd_a_01010.8b95ea46.png";